import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type RegisterMyPushSubscriptionMutationVariables = Types.Exact<{
  input: Types.RegisterMyPushSubscriptionInput;
}>;


export type RegisterMyPushSubscriptionMutation = { __typename?: 'Mutation', registerMyPushSubscription: { __typename?: 'PushSubscriptionPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type RemoveMyPushSubscriptionMutationVariables = Types.Exact<{
  input: Types.RemoveMyPushSubscriptionInput;
}>;


export type RemoveMyPushSubscriptionMutation = { __typename?: 'Mutation', removeMyPushSubscription: { __typename?: 'RemovePushSubscriptionPayload', removed: boolean, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const RegisterMyPushSubscriptionDocument = new TypedDocumentString(`
    mutation RegisterMyPushSubscription($input: RegisterMyPushSubscriptionInput!) {
  registerMyPushSubscription(input: $input) {
    errors {
      code
      message
    }
  }
}
    `);
export const RemoveMyPushSubscriptionDocument = new TypedDocumentString(`
    mutation RemoveMyPushSubscription($input: RemoveMyPushSubscriptionInput!) {
  removeMyPushSubscription(input: $input) {
    removed
    errors {
      code
      message
    }
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    RegisterMyPushSubscription: build.mutation<RegisterMyPushSubscriptionMutation, RegisterMyPushSubscriptionMutationVariables>({
      query: (variables) => ({ document: RegisterMyPushSubscriptionDocument, variables })
    }),
    RemoveMyPushSubscription: build.mutation<RemoveMyPushSubscriptionMutation, RemoveMyPushSubscriptionMutationVariables>({
      query: (variables) => ({ document: RemoveMyPushSubscriptionDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useRegisterMyPushSubscriptionMutation, useRemoveMyPushSubscriptionMutation } = injectedRtkApi;
